import { useState, useEffect, useRef, type FC, useId } from "react";
import { useScroll } from "../../../contexts/useScroll";
import StarIcon from "../../../components/icons/StarIcon";

interface RatingInputProps {
  options: string[];
  onSubmit: (rating: string) => void;
}

const RatingInput: FC<RatingInputProps> = ({ options, onSubmit }) => {
  const { scrollToBottomIfNearBottom } = useScroll();
  const [hoverRating, setHoverRating] = useState<number | null>(null);
  const id = useId();
  const rootRef = useRef<HTMLDivElement | null>(null);
  const limitedOptions = options.slice(0, 5); // Limit to 5 options

  useEffect(() => {
    // `setTimeout` used to ensure DOM is updated before scroll attempt.
    // Conditional for the same reason as ChatMessageListOptions (LAS-1381).
    setTimeout(() => scrollToBottomIfNearBottom(rootRef.current?.offsetHeight ?? 0), 0);
  }, [scrollToBottomIfNearBottom]);

  return (
    <div ref={rootRef} className="flex">
      {limitedOptions.map((option, i) => (
        <button
          type="button"
          key={`${id}-${i}`}
          onMouseEnter={() => setHoverRating(i + 1)}
          onMouseLeave={() => setHoverRating(null)}
          onClick={() => onSubmit(`{{${"★".repeat(i + 1)}}} ${option}`)}
          style={{
            paddingLeft: `${i > 0 ? "0.25rem" : ""}`,
            paddingRight: `${i < options.length - 1 ? "0.25rem" : ""}`
          }}
          className="pb-4 transform opacity-0 animate-fade-in duration-300 cursor-pointer"
        >
          <span className="p-2.5 bg-lastbot-surface-subtle rounded-lg block">
            <StarIcon active={hoverRating !== null && hoverRating >= i + 1} />
          </span>
        </button>
      ))}
    </div>
  );
};

export default RatingInput;
